import React from "react";
import Form from "./components/Form/Form";
import { Header } from "./components/Header/Header";
import { Footer } from "./components/Footer/Footer";

const App = () => {
  return (
    <>
      <Header />
      <Form />
      <Footer />
    </>
  );
};

export default App;
